export default __webpack_public_path__ + "static/media/approved_feedback_activity_course.8d38ba09.svg";